import fwUtil from 'framework-util'

const sentimentDistributionService = new fwUtil.ApiService.ApiService('sentimentDistribution');


export { sentimentDistributionService }

  export function getDistributionByDate(data){
    return custemRequest({
      url: 'sentimentDistribution/list/byDay',
      method: 'get',
      params: data
    })
  }


// WEBPACK FOOTER //
// ./src/api/pubsentiment/sentimentDistribution.js